export default __webpack_public_path__ + "static/media/features.3.69cb1f69.svg";